import { useMemo } from 'react';

import { keyOf, TokenFormatter, PermissionsFormatter } from '@Components/Grid/components/Table/formatters'
import column, { defaultActiveColumn } from '@Components/Grid/utils/column';

import AcitveToggle from './ActiveFormatter';
import DescriptionFormatter from './DescriptionFormatter';

export default function useColumns() {
  return useMemo(() => [
    column.accessor('id', {
      header: 'Token',
      cell: info => <TokenFormatter info={info} canCopy={false} disabledTooltip={'You can copy token only the creation event.'} />,
      enableSorting: false,
      maxSize: 100,
    }),
    column.accessor('description', {
      header: 'Description',
      cell: info => <DescriptionFormatter info={info} />,
    }),
    column.accessor('meta.permissions', {
      header: 'Permissions',
      cell: info => <PermissionsFormatter info={info} />,
      enableSorting: false,
    }),
    defaultActiveColumn(),
  ], [])
}

export function toggleFormatter(info) {
  return <AcitveToggle key={keyOf(info)} info={info} />
}
